(function($) {
	'use strict';

	var $navbar_toggler = $('#navbar-toggler'); 

	$('#navbar-toggler').on('click tap press', function (e) {
        $('.header-menu').toggleClass('open');
        $('body').toggleClass('menu-toggled');
        $navbar_toggler.toggleClass('collapsed');
    });

	const myModal = new HystModal({
	    linkAttributeName: "data-hystmodal",
		//settings (optional). see API
	});


  window.addEventListener("scroll", function() {
      const scrolledPosition = window.scrollY; // Get current scroll position

      if (scrolledPosition >= 50) {
        // Do something when scrolled more than 50px
        $('header.site-header').addClass('scrolled');
      } else if (scrolledPosition === 0) {
       $('header.site-header').removeClass('scrolled');
      }
  });


	$(".gfield input, .gfield textarea").focusout(function(){
             if($(this).val() !== ""){
               $(this).addClass("has-content");
               $(this).closest('.gfield').addClass("has-content");
             } else {
             $(this).removeClass("has-content");
             $(this).closest('.gfield').removeClass('focus');
            }
          }); 
          $('.gfield input, .gfield textarea').focus(function() {
            $(this).closest('.gfield').addClass('focus');
          });

          $(window).on("load", function (e) {
            $(".gfield input, .gfield textarea").each(function(){
             if($(this).val() !== ""){
               $(this).addClass("has-content");
               $(this).closest('.gfield').addClass("has-content");
             }
            });
          });

          $('input[type=checkbox]').change(function() {
            $("input[type=checkbox]").parent().removeClass("selected");
            $("input[type=checkbox]:checked").parent().addClass("selected");
            // console.log($("input[name='ad_caroserie']:checked").val());
          });
          $('input[type=radio]').change(function() {
            $("input[type=radio]").parent().removeClass("selected");
            $("input[type=radio]:checked").parent().addClass("selected");
            // console.log($("input[name='ad_caroserie']:checked").val());
          });

       $(document).on('gform_page_loaded', function(){
  
         $(".gfield input, .gfield textarea").focusout(function(){
             if($(this).val() !== ""){
               $(this).addClass("has-content");
               $(this).closest('.gfield').addClass("has-content");
             } else {
             $(this).removeClass("has-content");
             $(this).closest('.gfield').removeClass('focus');
            }
          }); 
          $('.gfield input, .gfield textarea').focus(function() {
            $(this).closest('.gfield').addClass('focus');
          });

          $(window).on("load", function (e) {
            $(".gfield input, .gfield textarea").each(function(){
             if($(this).val() !== ""){
               $(this).addClass("has-content");
               $(this).closest('.gfield').addClass("has-content");
             }
            });
          });

          $('input[type=checkbox]').change(function() {
            $("input[type=checkbox]").parent().removeClass("selected");
            $("input[type=checkbox]:checked").parent().addClass("selected");
            // console.log($("input[name='ad_caroserie']:checked").val());
          });
          $('input[type=radio]').change(function() {
            $("input[type=radio]").parent().removeClass("selected");
            $("input[type=radio]:checked").parent().addClass("selected");
            // console.log($("input[name='ad_caroserie']:checked").val());
          });

        });


        // ----------------------
       // Slick Sliders
       // ----------------------
        $('.slideshow').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          dots: true,
          fade: false,
          autoplay: false,
          autoplaySpeed: 4500,
        });

        // ripple-model

        // var ripple = $('.ripple-model svg');
        // var purple = $('#purple');
        // var black = $('#black');
        // var green = $('#green');

        // var panel_purple = $('.panel-purple');
        // var panel_black = $('.panel-black');
        // var panel_green = $('.panel-green');

  
        
        $(document).ready(function() {

          // Image captions

          var images = $('.hover-image img');

          // Loop through each image
          images.each(function() {
            var altText = $(this).attr('alt');

            // Check if alt text exists (optional)
            if (altText) {
              // Create a caption element
              var caption = $('<span class="caption">').text(altText);

              // Add the caption element after the image
              $(this).after(caption);
            }
          });

          // Define the SVG paths and their corresponding divs
          const svgPaths = {
            "#green": $(".wp-block-group.panel-green"),
            "#black": $(".wp-block-group.panel-black"),
            "#purple": $(".wp-block-group.panel-purple"),
          };

          // Loop through each SVG path
          $.each(svgPaths, function(pathSelector, div) {
            $(pathSelector).on({
              mouseenter: function() {
                // Show the corresponding div on hover
                $(this).addClass('active');
                div.addClass('active');
              },
              mouseleave: function() {
                // Hide the corresponding div on hover out
                div.removeClass('active');
                $(this).removeClass('active');
              }
            });
          });
        });


  class Accordion {
    constructor(el) {
      // Store the <details> element
      this.el = el;
      // Store the <summary> element
      this.summary = el.querySelector('summary');
      // Store the <div class="content"> element
      this.content = el.querySelector('.content');

      // Store the animation object (so we can cancel it if needed)
      this.animation = null;
      // Store if the element is closing
      this.isClosing = false;
      // Store if the element is expanding
      this.isExpanding = false;
      // Detect user clicks on the summary element
      this.summary.addEventListener('click', (e) => this.onClick(e));
    }

    onClick(e) {
      // Stop default behaviour from the browser
      e.preventDefault();
      // Add an overflow on the <details> to avoid content overflowing
      this.el.style.overflow = 'hidden';
      // Check if the element is being closed or is already closed
      if (this.isClosing || !this.el.open) {
        this.open();
      // Check if the element is being openned or is already open
      } else if (this.isExpanding || this.el.open) {
        this.shrink();
      }
    }

    shrink() {
      // Set the element as "being closed"
      this.isClosing = true;
      
      // Store the current height of the element
      const startHeight = `${this.el.offsetHeight}px`;
      // Calculate the height of the summary
      const endHeight = `${this.summary.offsetHeight}px`;
      
      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }
      
      // Start a WAAPI animation
      this.animation = this.el.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: 'ease-out'
      });
      
      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(false);
      // If the animation is cancelled, isClosing variable is set to false
      this.animation.oncancel = () => this.isClosing = false;
    }

    open() {
      // Apply a fixed height on the element
      this.el.style.height = `${this.el.offsetHeight}px`;
      // Force the [open] attribute on the details element
      this.el.open = true;
      // Wait for the next frame to call the expand function
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      // Set the element as "being expanding"
      this.isExpanding = true;
      // Get the current fixed height of the element
      const startHeight = `${this.el.offsetHeight}px`;
      // Calculate the open height of the element (summary height + content height)
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
      
      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }
      
      // Start a WAAPI animation
      this.animation = this.el.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: 'ease-out'
      });
      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(true);
      // If the animation is cancelled, isExpanding variable is set to false
      this.animation.oncancel = () => this.isExpanding = false;
    }

    onAnimationFinish(open) {
      // Set the open attribute based on the parameter
      this.el.open = open;
      // Clear the stored animation
      this.animation = null;
      // Reset isClosing & isExpanding
      this.isClosing = false;
      this.isExpanding = false;
      // Remove the overflow hidden and the fixed height
      this.el.style.height = this.el.style.overflow = '';
    }
  }

  document.querySelectorAll('details').forEach((el) => {
    new Accordion(el);
  });


})(jQuery);
